<template>
  <div
    class="board-grid"
    :style="{
      'grid-template-rows':    `repeat(${rows}, ${cellSize}px)`,
      'grid-template-columns': `repeat(${columns}, ${cellSize}px)`,
    }"
  >
    <board-cell
      v-for="(cell, index) in table"
      :key="`${cell.positiony}-${cell.positionx}`"
      :cell="cell"
      :cell-size="cellSize"
      :settings="settings"
      :data-index="index"
      :style="{ width: cellSize + 'px', height: cellSize + 'px' }"
      @click="$emit('cell-click', $event)"
    />
  </div>
</template>

<script>
import BoardCell from './BoardCell.vue';

export default {
  name: 'board-grid',
  components: { BoardCell },
  props: {
    table: { type: Array, required: true },
    rows: { type: Number, required: true },
    columns: { type: Number, required: true },
    cellSize: { type: Number, default: 60 },
    settings: { type: Object, required: true },
  },
};
</script>

<style scoped>
.board-grid {
  display: grid;
  border: 2px solid #000;
  width: fit-content;
}
</style>
